module.exports = __webpack_public_path__ + "img/common-popup-hen.9512f69c.png";